import Modal, { ModalData } from "@/components/modal/Modal";
import PageContainer        from "@/components/pageContainer/PageContainer";
import PageTitle            from "@/components/pageTitle/PageTitle";
import TransfersListBox     from "@/pages/Transfers/components/TransfersListBox";
import React                from "react";
import { useTranslation }   from "react-i18next";

const TransfersPage = () => {
	const { t } = useTranslation();

	const [modalData, setModalData] = React.useState<ModalData | undefined>();
	const [modalIsOpen, setModalIsOpen] = React.useState(false);
	
	return (
		<PageContainer>
			<Modal
				model={modalData?.model}
				isDangerous={modalData?.isDangerous}
				isOpen={modalIsOpen}
				setIsOpen={setModalIsOpen}
				titleComponent={modalData?.titleComponent}
				bodyComponent={modalData?.bodyComponent}
				onConfirm={modalData?.onConfirm}
				onClose={modalData?.onClose}
				onSuccess={modalData?.onSuccess}
			/>
			<PageTitle>
				{t('pages.transfers.label')}
			</PageTitle>
			<TransfersListBox setModalData={setModalData} setModalIsOpen={setModalIsOpen} />
		</PageContainer>
	);
};

export default TransfersPage;